export const useStoreClasses = defineStore('StoreClasses', {
    state: () => ({
        classes: null,
        error: null,
        filter: {
            paginate: {
                auto: false,
            },
        },
    }),
    actions: {
        async initClasses() {
            if (this.classes) return Promise.resolve(this.classes);
            return this.getClasses();
        },
        async getClasses() {
            this.error = null;
            ({classes: this.classes, error: this.error} = await useQueryClasses().get(this.filter));
        },
    },
    getters: {
        filterClasses() {
            let classes = [];
            if (!this.classes) return classes;
            this.classes.map((item) => {
                classes.push({
                    slug: item.class_slug,
                    name: item.class_name,
                    lat: item.class_latitude,
                    lng: item.class_longitude,
                });
            });
            return classes;
        },
        searchClasses() {
            return ({searchText}) => {
                if (!this.classes) return [];
                let classes = this.classes.filter(
                    (item) =>
                        item.class_name.toLowerCase().includes(searchText.toLowerCase()) ||
                        (item.class_address && item.class_address.toLowerCase().includes(searchText.toLowerCase())),
                );
                let results = [];
                classes.map((item) => {
                    results.push({
                        slug: item.class_slug,
                        name: item.class_name,
                        address: item.class_address,
                        lat: item.class_latitude,
                        lng: item.class_longitude,
                    });
                });
                return results;
            };
        },
    },
});
